<template>
  <div id="toolUI" v-show="isShow">
    <div class="debugControl textDebugTool" v-show="isTextMode">
      text<br />rot
      <input
        type="range"
        min="0"
        max="360"
        v-model.number="tool.text.rotation"
      />
      {{ tool.text.rotation | round }}

      scale
      <input
        type="range"
        min="0"
        max="2"
        step="0.1"
        v-model.number="tool.text.scale"
      />
      {{ tool.text.scale }}
      <br />
      x
      <input type="range" min="-300" max="300" v-model.number="tool.text.x" />
      {{ tool.text.x | round }}, y
      <input type="range" min="-300" max="300" v-model.number="tool.text.y" />
      {{ tool.text.y | round }}
      <button class="buttonMini buttonMini--circle" @click="completeTextEdit">
        OK
      </button>
    </div>
    <div class="toolUIContainer">
      <div
        class="tutorialTooltips"
        v-show="isTutorialToolUI_"
        :class="{ show: isTutorialToolUI_ }"
        :style="{ transform: `scale(${scale})` }"
      >
        <div class="tutorialTooltips__color tutorialTooltips__item">
          <img src="../../assets/tutorial/color.png" width="78" alt="" />
        </div>
        <div class="tutorialTooltips__spray tutorialTooltips__item">
          <img src="../../assets/tutorial/spray.png" width="80" alt="" />
        </div>
        <div class="tutorialTooltips__pen tutorialTooltips__item">
          <img src="../../assets/tutorial/pen.png" width="55" alt="" />
        </div>
        <div class="tutorialTooltips__key tutorialTooltips__item">
          <img src="../../assets/tutorial/key.png" width="80" alt="" />
        </div>
      </div>
      <div
        class="paletteScaleContainer"
        :style="{ transform: `scale(${scale})` }"
      >
        <div :class="{ 'palette--open': paletteOpen }" class="palette">
          <SizePalette class="palette__size"></SizePalette>
          <div class="palette__color">
            <div v-for="(i, index) in new Array(8)" class="palette__colorItem">
              <div
                class="colorButton"
                :class="{ selected: isSelectedColor(index) }"
              >
                <div
                  class="colorButton__color"
                  :style="{ backgroundColor: getColor(index) }"
                  @click="changeColor(index)"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="selectors">
        <div
          class="selectorsContainer"
          :style="{ transform: `scale(${scale})`, top: `${offsetY}px` }"
        >
          <div class="selectors__separator"></div>
          <div class="colorSelector selectorItem">
            <div class="toolColor">
              <div class="toolColor__button" @click="toggleColor">
                <div
                  :class="toolColorClass"
                  class="toolColor__buttonColor"
                ></div>
              </div>
            </div>
          </div>
          <div class="sprayButton selectorItem">
            <div
              ref="sprayButton__img"
              class="sprayButton__img toolSelector"
              :class="{ selected: isSelectedTool(1) }"
            >
              <div
                class="toolCan "
                :class="`can-${color}`"
                @click="select(1)"
              ></div>
            </div>
          </div>
          <div class="markerButton selectorItem">
            <div
              ref="markerButton__img"
              class="markerButton__img toolSelector"
              :class="{ selected: isSelectedTool(2) }"
            >
              <div
                class="toolMarker "
                :class="`marker-${color}`"
                @click="select(2)"
              ></div>
            </div>
          </div>
          <div class="textButton selectorItem">
            <div
              ref="textButton__img"
              class="textButton__img toolSelector"
              :class="{ selected: isSelectedTool(3) }"
            >
              <div
                class="toolKey "
                :class="`key-${color}`"
                @click="select(3)"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../store/modules/tool/types";
import { DrawEvent } from "../../events/DrawEvent";
import SizePalette from "./SizePalette";
import {
  isModeDraw,
  isToolText,
  isTextTransform,
  isTutorialToolUI
} from "../../util/StoreUtil";
import * as StoreUtil from "../../util/StoreUtil";
import { TweenMax, Expo, Bounce } from "gsap";
const els = ["sprayButton__img", "markerButton__img", "textButton__img"];
export default {
  name: "ToolUI",
  components: { SizePalette },
  computed: {
    paletteOpen: {
      get() {
        return this.$store.state.tool.paletteOpen;
      },
      set(value) {
        this.$store.dispatch(types.namespace + types.SET_PALETTE_OPEN, value);
      }
    },
    colorPalette() {
      return this.$store.state.tool.colorPalette;
    },
    tool() {
      return this.$store.state.tool;
    },
    toolTool() {
      return this.$store.state.tool.tool;
    },
    isShow() {
      if (isModeDraw() && StoreUtil.isTextTransform()) return false;
      if (isTutorialToolUI()) return true;
      return isModeDraw();
    },
    isTutorialToolUI_() {
      return isTutorialToolUI();
    },
    toolColorClass() {
      return "toolColor--" + this.tool.color;
    },
    color() {
      return this.tool.color;
    },
    isTextMode() {
      return isToolText() && isTextTransform();
    }
  },
  data() {
    return {
      scale: 1,
      offsetY: 0
    };
  },
  mounted() {
    console.log("mounted");
    const w = 375;
    if (window.innerWidth < w) {
      this.scale = window.innerWidth / w;
      this.offsetY = -0.327272727 * (window.innerWidth - w);
    }
  },
  watch: {
    isTutorialToolUI_(newVal, oldVal) {
      if (newVal) {
        console.log("show!");
        this.showToolTips();
      } else {
        this.paletteOpen = true;
      }
    },
    color() {
      this.selectAnim();
    },
    toolTool() {
      this.selectAnim();
    }
  },
  methods: {
    selectAnim() {
      const el = this.$refs[els[this.tool.tool - 1]];
      const y = -18;
      // const upDuration = 0.0;
      // TweenMax.fromTo(el, upDuration, { y: 0 }, { y: y, ease: Expo.easeOut });
      TweenMax.fromTo(el, 0.3, { y: y }, { y: 0, ease: Bounce.easeOut });
    },
    showToolTips() {
      TweenMax.staggerFromTo(
        ".tutorialTooltips__item",
        0.5,
        { opacity: 0, y: -30 },
        { opacity: 1, y: 0, ease: Expo.easeOut },
        0.05
      );
      TweenMax.staggerFromTo(
        ".selectorItem",
        0.5,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, ease: Expo.easeOut },
        0.05
      );
    },
    changeColor(type) {
      this.$store.dispatch(types.namespace + types.SET_COLOR, type);
    },
    changeSize(type) {
      this.$store.dispatch(types.namespace + types.SET_SIZE, type);
    },
    toggleColor() {
      if (this.isTutorialToolUI_) return;
      this.paletteOpen = !this.paletteOpen;
    },
    select(name) {
      if (this.isTutorialToolUI_) return;
      this.$store.dispatch(types.namespace + types.SET_TOOL, name);
    },
    getColor(index) {
      return this.colorPalette[index];
    },
    isSelectedTool(index) {
      if (this.isTutorialToolUI_) return true;
      return this.tool.tool == index;
    },
    isSelectedColor(index) {
      return this.tool.color == index;
    },
    isSelectedSize(index) {
      return this.tool.size == index;
    },
    completeTextEdit() {
      console.log("complete");
      DrawEvent.emit("complete");
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/colors"
@import "../../sass/zindex"
@import "../../sass/common"
@import "../../sass/colorbutton"
.textDebugTool
    margin-top: 55px
    margin-left: 10px
    font-size: 10px
    pointer-events: all
    input
        width: 100px
    .buttonMini--circle
        display: inline-flex
#toolUI
    pointer-events: none
    position: absolute
    z-index: $z_tool_ui
    top: 0
    left: 0
    right: 0
    bottom: 0
    .toolUIContainer
        transform-origin: left bottom
        max-width: 375px
        margin: auto
        //position: relative
.tutorialTooltips
    position: absolute
    transform-origin: left bottom
    bottom: 0px
    opacity: 1
    z-index: 10
    transition: ease-out 0.5s
    height: 170px
    overflow: hidden
    width: 375px
    > div
        position: absolute
    .tutorialTooltips__color
        left: 11px
    .tutorialTooltips__spray
        left: 111px
    .tutorialTooltips__pen
        left: 211px
    .tutorialTooltips__key
        left: 283px
.paletteScaleContainer
    transform-origin: left bottom
    width: 375px
    pointer-events: none
    position: absolute
    bottom: 104px
    z-index: 10
.palette
    box-sizing: border-box
    position: absolute
    box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.9)
    bottom: 0px
    width: 375px
    //bottom: 100px
    /*height: 135px*/
    background-color: $palette_bg
    border: 1.5px solid $button_border
    border-radius: 12px
    padding: 15px 10px 22px
    transform: translateY(-12px)
    opacity: 0
    display: block
    transition: all cubic-bezier(0.790, -0.010, 0.145, 0.990) 0.12s
    &.palette--open
        transform: translateY(0)
        opacity: 1
        pointer-events: all
        display: block
    &:after
        content: ""
        display: block
        position: absolute
        width: 31px
        height: 21px
        background: url("../../assets/tool/palette-fukidashi.png") no-repeat 0 0
        background-size: 31px 21px
        left: 26px
        bottom: -19px
    .palette__color
        height: 34px
        display: flex
        align-items: center
        justify-content: space-between
        position: relative
        z-index: 1
        padding-left: 1px
        padding-right: 9px
        .palette__colorItem
            width: 28px
            height: 28px

.selectors
    $selector-pad: 18px
    height: 120px + $selector-pad
    background: url("../../assets/tool/toolUI-bg.png") repeat-x top left
    background-size: contain
    overflow: hidden
    pointer-events: all
    position: absolute
    left: 0
    right: 0
    bottom: 0
    .selectorsContainer
      transform-origin: left bottom
      position: relative
      margin: auto
      max-width: 375px
      .selectors__separator
          top: 48px
          left: 86px
          height: 80px
          width: 2px
          border-left: 1px solid black
          background-color: white
          opacity: 0.6
      > div
          position: absolute
      .colorSelector
          left: 0px
          top: 61px
      .sprayButton
          left: 110px
          top: 19px + $selector-pad
      .markerButton
          left: 200px
          top: 17px + $selector-pad
      .textButton
          left: 295px
          top: 40px + $selector-pad
.toolColor
    position: absolute
    left: 19px
    height: 48px
    .toolColor__button
        width: 48px
        height: 48px
        position: relative
        border-radius: 48px
        background-color: $button_bg
        border: 6px solid $button_border

        .toolColor__buttonColor
            position: absolute
            width: 30px
            height: 30px
            border-radius: 30px
            top: 3px
            left: 3px
            background-color: #fff
            &.toolColor--0
                background-color: nth($palette, 1)
            &.toolColor--1
                background-color: nth($palette, 2)
            &.toolColor--2
                background-color: nth($palette, 3)
            &.toolColor--3
                background-color: nth($palette, 4)
            &.toolColor--4
                background-color: nth($palette, 5)
            &.toolColor--5
                background-color: nth($palette, 6)
            &.toolColor--6
                background-color: nth($palette, 7)
            &.toolColor--7
                background-color: nth($palette, 8)

//.toolSelector
    transition: transform ease-out 0.08s, filter ease-in-out 0.3s
    transform: translateY(0)
    &.selected
        transform: translateY(-15px)


.toolCan
    width: 188px * 0.5
    height: 299px * 0.5
    background-image: url("/img/ui/tool/can.png")
    background-size: 980px*0.5 614px*0.5
    background-position:  -592px*0.5 -311px*0.5 // disabled
    .selected &
        &.can-0
            background-position: -4px*0.5 -4px*0.5
        &.can-2
            background-position: -200px*0.5 -4px*0.5
        &.can-3
            background-position: -396px*0.5 -4px*0.5
        &.can-4
            background-position: -592px*0.5 -4px*0.5
        &.can-5
            background-position: -4px*0.5 -311px*0.5
        &.can-6
            background-position: -200px*0.5 -311px*0.5
        &.can-7
            background-position: -396px*0.5 -311px*0.5
        &.can-disable
            background-position: -592px*0.5 -311px*0.5
        &.can-1
            background-position: -788px*0.5 -4px*0.5

.toolMarker
    width: 177px * 0.5
    height: 301px * 0.5
    background-image: url("/img/ui/tool/marker.png")
    background-size: 925px*0.5 617px*0.5
    background-position: -744px*0.5 -4px*0.5
    .selected &
        &.marker-7
            background-position: -4px*0.5 -4px*0.5
        &.marker-0
            background-position: -189px*0.5 -4px*0.5
        &.marker-1
            background-position: -374px*0.5 -4px*0.5
        &.marker-2
            background-position: -559px*0.5 -4px*0.5
        &.marker-3
            background-position: -4px*0.5 -313px*0.5
        &.marker-4
            background-position: -189px*0.5 -313px*0.5
        &.marker-5
            background-position: -374px*0.5 -313px*0.5
        &.marker-6
            background-position: -559px*0.5 -313px*0.5
        &.marker-disable
            background-position: -744px*0.5 -4px*0.5


.toolKey
    width: 120px*0.5
    height: 117px*0.5

    background-size: 548px*0.5 403px*0.5
    background-image: url("/img/ui/tool/key.png")
    background-position: -4px*0.5 -282px*0.5
    .selected &
      width: 129px*0.5
      height: 131px*0.5
      &.key-0
        background-position: -4px*0.5 -4px*0.5
      &.key-1
        background-position: -141px*0.5 -4px*0.5
      &.key-2
        background-position: -278px*0.5 -4px*0.5
      &.key-3
        background-position: -4px*0.5 -143px*0.5
      &.key-4
        background-position: -141px*0.5 -143px*0.5
      &.key-5
        background-position: -278px*0.5 -143px*0.5
      &.key-6
        background-position: -415px*0.5 -4px*0.5
      &.key-7
        background-position: -415px*0.5 -143px*0.5
</style>
